import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Twitter, Mail, ArrowUpRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-rich-black pt-32 pb-12 relative overflow-hidden" data-id="element-144">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[300px] bg-gold/10 rounded-full blur-[150px] pointer-events-none" data-id="element-145" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-146">
        <div className="text-center max-w-4xl mx-auto mb-24" data-id="element-147">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-5xl md:text-7xl font-bold leading-tight mb-8" data-id="element-148">
            "Experience earned but the learning never stops. <br data-id="element-149" />
            <span className="text-gradient-gold" data-id="element-150">Future unlocked."</span>
          </motion.h2>

          <motion.button initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="px-10 py-5 bg-white text-rich-black font-sans font-bold text-lg rounded-full hover:scale-105 transition-transform flex items-center gap-2 mx-auto" data-id="element-151">
            Choose Your Destination <ArrowUpRight size={24} data-id="element-152" />
          </motion.button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center pt-12 border-t border-white/10" data-id="element-153">
          {/* Brand */}
          <div className="text-center md:text-left" data-id="element-154">
            <h3 className="font-display text-2xl font-bold text-white mb-2" data-id="element-155">
              Amoye40
            </h3>
            <p className="font-sans text-sm text-gray-500" data-id="element-156">
              The Global Celebration • 2027
            </p>
          </div>

          {/* Socials */}
          <div className="flex justify-center gap-6" data-id="element-157">
            <a href="#" className="w-12 h-12 rounded-full glass-panel flex items-center justify-center text-white hover:text-gold hover:border-gold/50 transition-all" data-id="element-158">
              <Instagram size={20} data-id="element-159" />
            </a>
            <a href="#" className="w-12 h-12 rounded-full glass-panel flex items-center justify-center text-white hover:text-gold hover:border-gold/50 transition-all" data-id="element-160">
              <Twitter size={20} data-id="element-161" />
            </a>
            <a href="#" className="w-12 h-12 rounded-full glass-panel flex items-center justify-center text-white hover:text-gold hover:border-gold/50 transition-all" data-id="element-162">
              <Mail size={20} data-id="element-163" />
            </a>
          </div>

          {/* Newsletter */}
          <div className="text-center md:text-right" data-id="element-164">
            <p className="font-sans text-sm text-gray-400 mb-3" data-id="element-165">
              Stay updated on the itinerary
            </p>
            <div className="flex max-w-sm ml-auto" data-id="element-166">
              <input type="email" placeholder="Email address" className="bg-white/5 border border-white/10 rounded-l-full px-4 py-2 text-sm text-white font-sans focus:outline-none focus:border-gold w-full" data-id="element-167" />
              <button className="bg-gold text-rich-black px-6 py-2 rounded-r-full font-sans font-bold text-sm hover:bg-white transition-colors" data-id="element-168">
                Join
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}